import { render, staticRenderFns } from "./batchRenew.vue?vue&type=template&id=60f3d9b0&scoped=true"
import script from "./batchRenew.vue?vue&type=script&lang=js"
export * from "./batchRenew.vue?vue&type=script&lang=js"
import style0 from "./batchRenew.vue?vue&type=style&index=0&id=60f3d9b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f3d9b0",
  null
  
)

export default component.exports